import script from "./BroadcastPageCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastPageCreator.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastPageCreator.vue?vue&type=style&index=0&id=22365af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22365af4"]])

export default __exports__